import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import UserRegistration from './components/user/UserRegistration';
import Login from './components/user/UserLogin';
import UserProfile from './components/user/UserProfile';
import SearchPage from './components/search/SearchPage';
import AgendaPage from './components/agenda/AgendaPage';
import AboutPage from './components/welcome/AboutPage';
import WhatsHotPage from './components/search/WhatsHotPage';
import PasswordReset from './components/user/PasswordReset';
import PasswordResetForm from './components/user/PasswordResetForm';
import GentleIntroPage from './components/welcome/GentleIntro';
import LandingPage from './components/welcome/LandingPage';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import JobsPage from './components/jobs/JobsPage';
import { AuthProvider, AuthContext } from './context/AuthContext';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/" element={<LandingPageWrapper />} />
          <Route path="/intro" element={<LandingPageWrapper />} />
          <Route path="/home" element={<PrivateRoute component={GentleIntroPage} />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/profile" element={<PrivateRoute component={UserProfile} />} />
          <Route path="/register" element={<UserRegistration />} />
          <Route path="/login" element={<Login />} />
          <Route path="/discover" element={<PrivateRoute component={SearchPage} />} />
          <Route path="/agenda" element={<PrivateRoute component={AgendaPage} />} />
          <Route path="/whats-hot" element={<PrivateRoute component={WhatsHotPage} />} />
          <Route path="/forgot-password" element={<PasswordReset />} />
          <Route path="/reset-password" element={<PasswordResetForm />} />
          <Route path="/jobs" element={<PrivateRoute component={JobsPage} />} />
        </Routes>
        <Footer />
      </AuthProvider>
    </ChakraProvider>
  );
}

const LandingPageWrapper = () => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? <Navigate to="/home" /> : <LandingPage />;
};

const PrivateRoute = ({ component: Component }) => {
  const { isAuthenticated } = useContext(AuthContext);
  return isAuthenticated ? <Component /> : <Navigate to="/" />;
};

export default App;
